import React from 'react'
import { connect } from 'react-redux'

import EmailSignupForm from './EmailSignupForm'

const Newsletter = () => (
  <EmailSignupForm
    action="/actions/business-logic/default/newsletter-signup/"
    successText={window.jsProps.strings.newsletterSuccess}
  />
)

const mapStateToProps = (_state: unknown) => ({})

function mapDispatchToProps(_dispatch: unknown) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Newsletter)
